module.exports = __webpack_public_path__ + "static/media/energy-smart-video.c399bfd0.jpg";